import React from 'react';
import Button from '../Common/Button';

const ServicosCTA: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-color-surface">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-color-text mb-6">Precisa de Ajuda?</h2>
        <p className="text-lg text-color-text-secondary mb-8 max-w-2xl mx-auto">
          Entre em contato conosco para mais informações sobre os serviços.
        </p>
        <a href="mailto:servicos@federacao.com.br">
          <Button variant="primary" size="lg">
            Enviar Mensagem
          </Button>
        </a>
      </div>
    </section>
  );
};

export default ServicosCTA;
